/**
 * index.html の <title> / meta description と整合。SPA 離脱時の復帰用。
 * index.html を変えた場合はここも同期すること。
 */
export const DEFAULT_DOCUMENT_TITLE = 'Social Trip - あなたの旅を診断';

export const DEFAULT_META_DESCRIPTION =
  'あなたにぴったりの旅行スタイルを診断し、最適な旅行プランをご提案します。';
